export default __webpack_public_path__ + "static/media/hero_2.6ce581a4.png";